<template>
  <!-- 添加分组 -->
  <div>
    <CustomDialog
      :show="show"
      :title="isEdit ? $t('public.editGT') : $t('public.addGT')"
      @toggleShow="handleClose"
      :appendToBody="true"
      width="800"
    >
      <!-- :title="$t('public.addG')" -->

      <div slot="main">
        <div class="info">
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="130px"
            class="demo-ruleForm"
            size="small"
          >
            <el-form-item :label="$t('public.bsSearch')">
              <el-input
                :placeholder="$t('public.p2')"
                v-model.trim="form.searchKey"
                size="small"
                @keyup.enter.native="toSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="toSearch"
                ></el-button>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('public.gName')" prop="group">
              <el-input
                :placeholder="$t('public.gName')"
                v-model.trim="form.group"
                size="small"
                style="width: 40%"
                maxlength="50"
              >
              </el-input>
              <el-checkbox
                style="margin: 0 50px"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >{{ $t("public.checkAll") }}</el-checkbox
              >
              <span
                >{{ $t("public.checked") }}{{ form.stationValue.length }}/{{
                  stations.length
                }}</span
              >
            </el-form-item>
            <div class="checkGroup" ref="checkGroup" @scroll="handleScroll">
              <el-checkbox-group
                v-model="form.stationValue"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="station in stations"
                  :label="station.label"
                  :key="station.id"
                >
                  {{ station.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <div class="btns">
          <el-button
            @click="confirm"
            type="primary"
            size="small"
            style="width: 100%"
            >{{ $t("public.submit") }}</el-button
          >
          <el-button @click="handleClose" size="small" style="width: 100%">{{
            $t("public.cancel")
          }}</el-button>
        </div>
      </div>
    </CustomDialog>
  </div>
</template>

<script>
import {
  getBaseNames,
  getStations,
  addStaGroup,
  updateStaGroup,
  getStaGroupStasList,
} from "@/api/index.js";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "OverseasStationManageViewList",
  components: {
    CustomDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectGroup: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  watch: {
    name: {
      handler(newV, oldV) {
        if (newV) {
          this.form.group = newV;
        }
      },
      deep: true,
    },
    show: {
      handler(newV, oldV) {
        if (newV) {
          this.toSearch().then((res) => {
            if (this.form.group) {
              // 如果从编辑进来携带组名搜索出该组名下的全部基站并全部选中
              this.getGroupToList();
              if (this.form.stationValue.length == this.stations.length) {
                // 如果从编辑进来获取到的基站和所有基站一样全选
                this.checkAll = true;
              }
            }
          });
          this.$nextTick(() => {
            if (Object.keys(this.selectGroup).length) {
              this.isEdit = true;
            } else {
              this.isEdit = false;
            }
          });
        }
      },
    },
  },
  data() {
    return {
      isEdit: false,
      total: 100,
      form: {
        group: "",
        searchKey: "",
        stationValue: [],
      },
      rules: {
        group: [{ required: true, message: this.$t("public.ver8"), trigger: "blur" }],
      },
      checkAll: false,
      checkedStations: [],
      stations: [],
    };
  },

  mounted() {
    this.getAllCheckValue();
  },

  methods: {
    // stationChange(e) {
    //   this.getGroupToList().then((res) => {
    //     this.checkAll = true;
    //     this.handleCheckAllChange(this.checkAll);
    //   });
    //   // console.log(e, "eeee")
    // },
    async getGroupToList() {
      let arr = [];
      let param = {
        groupId: this.selectGroup.groupId,
      };
      let res = await getStaGroupStasList(param);
      arr = res.data.map((item) => {
        return item.nm;
      });
      this.form.stationValue = arr;
    },
    handleScroll() {
      const container = this.$refs.checkGroup;
      const scrollHeight = container.scrollHeight;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight && !this.loading) {
        // this.loadMore()
      }
    },
    getAllCheckValue() {
      this.checkedStations = this.stations.map((item) => {
        return item.id;
      });
      return this.checkedStations;
    },
    handleCheckAllChange(val) {
      this.checkedStations = this.stations.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.stationValue = val ? this.checkedStations : [];
      });
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.stations.length;
      //   this.isIndeterminate =
      //     checkedCount > 0 && checkedCount < this.stations.length;
    },
    async toSearch() {
      let param = {
        stationName: this.form.searchKey,
      };
      this.stations = [];
      let res = await getStations(param);
      if (res.data)
        this.stations = res.data.map((item, index) => {
          return {
            label: item.nm,
            id: item.nm,
          };
        });
    },
    confirm() {
      // console.log(this.form, "123123");
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.form.stationValue.length) {
            this.$message.warning(this.$t("public.p8"));
            return;
          }
          if (this.isEdit) {
            let param = {
              groupId: this.selectGroup.groupId,
              groupName: this.form.group,
              stationsName: this.form.stationValue.join("|"),
            };
            // 编辑
            updateStaGroup(param).then((res) => {
              if (res.code == 200) {
                // this.$message.success("编辑基站组成功");
                this.$message.success(this.$t("public.success1"));
                this.$emit("refush");
                this.handleClose();
              }
            });
          } else {
            // 新增
            let param = {
              groupName: this.form.group,
              stationsName: this.form.stationValue.join("|"),
            };
            addStaGroup(param).then((res) => {
              if (res.code == 200) {
                this.$message.success(this.$t("public.success2"));
                this.$emit("refush");
                this.handleClose();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("update:show", false);
      this.$emit("update:name", "");
      this.form = {
        group: "",
        searchKey: "",
        stationValue: [],
      };
      this.checkAll = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkGroup {
  border: 1px solid #eeeeee;
  padding: 10px;
  max-height: 100px;
  margin-left: 10px;
  overflow: auto;
}
</style>
